import { useState } from "react";

import { Card } from "@jti/core-components/components/Card";

import { useCartOverviewTierContext } from "../../context";
import { CartOverviewTierContent } from "../CartOverviewTierContent";
import { CartOverviewTierProgress } from "../CartOverviewTierProgress";

import styles from "../../CartOverviewTier.module.scss";

export const CartOverviewTierCard = () => {
  const { title, defaultCollapsed, descriptionCollapsed, descriptionExpanded, hasTierContent } =
    useCartOverviewTierContext();
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed ?? true);

  const description = isCollapsed ? descriptionCollapsed : descriptionExpanded;

  if (!hasTierContent) {
    return (
      <Card variant="level-2" title={title} description={description} data-testid="cart-overview-tier">
        <div className={styles.cartOverviewTier}>
          <CartOverviewTierContent />
        </div>
      </Card>
    );
  }

  return (
    <Card
      variant="level-2"
      isCollapsible
      isCollapsed={isCollapsed}
      onToggle={setIsCollapsed}
      defaultCollapsed={isCollapsed}
      title={title}
      description={description}
      nonCollapsibleContent={
        <div className={styles.cartOverviewTier}>
          <CartOverviewTierContent />
        </div>
      }
      data-testid="cart-overview-tier"
    >
      <CartOverviewTierProgress />
    </Card>
  );
};
